import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = ({ isActive, ...rest }) => {
  return isActive ? (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M19.878 7.24023C20.8531 7.33615 21.5094 7.55291 21.9993 8.04279C22.878 8.92147 22.878 10.3357 22.878 13.1641C22.878 15.9925 22.878 17.4068 21.9993 18.2854C21.1206 19.1641 19.7064 19.1641 16.878 19.1641H11.878C9.04956 19.1641 7.63535 19.1641 6.75667 18.2854C6.26677 17.7955 6.05001 17.1392 5.9541 16.1641"
        stroke="#F59C53"
        strokeWidth="1.5"
      />
      <path
        d="M2.87793 10.1641C2.87793 7.33564 2.87793 5.92142 3.75661 5.04274C4.63529 4.16406 6.0495 4.16406 8.87793 4.16406H13.8779C16.7064 4.16406 18.1206 4.16406 18.9992 5.04274C19.8779 5.92142 19.8779 7.33564 19.8779 10.1641C19.8779 12.9925 19.8779 14.4067 18.9992 15.2854C18.1206 16.1641 16.7064 16.1641 13.8779 16.1641H8.87793C6.0495 16.1641 4.63529 16.1641 3.75661 15.2854C2.87793 14.4067 2.87793 12.9925 2.87793 10.1641Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M13.8779 10.1641C13.8779 11.5448 12.7586 12.6641 11.3779 12.6641C9.99722 12.6641 8.87793 11.5448 8.87793 10.1641C8.87793 8.78335 9.99722 7.66406 11.3779 7.66406C12.7586 7.66406 13.8779 8.78335 13.8779 10.1641Z"
        stroke="#F59C53"
        strokeWidth="1.5"
      />
      <path d="M16.8779 12.1641L16.8779 8.16406" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M5.87793 12.1641L5.87793 8.16406" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M19.8779 7.72852C20.8529 7.82443 21.5093 8.04119 21.9992 8.53108C22.8779 9.40976 22.8779 10.824 22.8779 13.6524C22.8779 16.4808 22.8779 17.895 21.9992 18.7737C21.1205 19.6524 19.7063 19.6524 16.8779 19.6524H11.8779C9.04944 19.6524 7.63522 19.6524 6.75654 18.7737C6.26665 18.2838 6.04989 17.6275 5.95398 16.6523"
        stroke="#888888"
        strokeWidth="1.5"
      />
      <path
        d="M2.87781 10.6523C2.87781 7.82392 2.87781 6.4097 3.75649 5.53102C4.63517 4.65234 6.04938 4.65234 8.87781 4.65234H13.8778C16.7062 4.65234 18.1204 4.65234 18.9991 5.53102C19.8778 6.4097 19.8778 7.82392 19.8778 10.6523C19.8778 13.4808 19.8778 14.895 18.9991 15.7737C18.1204 16.6523 16.7062 16.6523 13.8778 16.6523H8.87781C6.04938 16.6523 4.63517 16.6523 3.75649 15.7737C2.87781 14.895 2.87781 13.4808 2.87781 10.6523Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M13.8778 10.6528C13.8778 12.0335 12.7585 13.1528 11.3778 13.1528C9.9971 13.1528 8.87781 12.0335 8.87781 10.6528C8.87781 9.27212 9.9971 8.15283 11.3778 8.15283C12.7585 8.15283 13.8778 9.27212 13.8778 10.6528Z"
        stroke="#888888"
        strokeWidth="1.5"
      />
      <path d="M16.8773 12.6528L16.8773 8.65283" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M5.87781 12.6528L5.87781 8.65283" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

export default Icon;
